import { connectRouter } from 'connected-react-router';
const loadRouterModule = (history) => ({
    id: 'Router',
    reducerMap: {
        router: connectRouter(history),
    },
});
export default loadRouterModule;
